/* global logoSliderOptions */
// The array coming from localize script in functions.php

import Swiper, { Navigation, Pagination, EffectFade } from 'swiper';

const testimonialSlider = document.querySelector('.front-testimonials__swiper')
if ( testimonialSlider ) {
	const testimonialSliderSwiper = new Swiper(".front-testimonials__swiper", {
        modules: [Navigation],
		slidesPerView: 1,
		loop: true,
		navigation: {
			nextEl: ".front-testimonials__next",
			prevEl: ".front-testimonials__prev",
		},
		// Responsive breakpoints
		breakpoints: {
			// when window width is >= 320px
			320: {
				slidesPerView: 1,

			},
			640: {
				slidesPerView: 2,
				spaceBetween: 40,

			},
			1025: {
				slidesPerView: 3,
				spaceBetween: 70,
			}
		}
	});
}

/**
 * Procedure slider with custom pagination
 */

// for procedure slider we need custom pagination, so we create
// array of names for it
let procedureLabels = [];

jQuery('.home-procedure-slider .swiper-slide').each((i, slide) => {
	procedureLabels.push(slide.dataset.title);
});

// procedures swiper slider
const proceduresSwiper = new Swiper ('.home-procedure-slider .swiper-container', {
	// Optional parameters
    modules: [Pagination, EffectFade],
	slidesPerView: 1,
	spaceBetween: 10,
	// centeredSlides: true,
	loop: true,
	effect: 'fade',
	fadeEffect: {
		crossFade: true
	},
	autoHeight: true,
	breakpoints: {
		992: {
			autoHeight: false
		}
	},
	// If we need pagination
	pagination: {
		el: '.home-procedure-slider__pagination',
		clickable: true,
		renderBullet: function (index, className) {
			return '<div class="' + className + '"><div class="inner">' + (procedureLabels[index]) + '<span>s</span></div></div>';
		}
	},
});


